import { css } from "@emotion/react"
import { ControlButton, controlButtonStyle } from "./ControlButton"
import { Scrubber } from "./Scrubber"
import { formatDuration, formatDatetimeDuration } from "./utils"
import type { PlayerRenderProps } from "./types"

const BUTTON_SIZE = 40
const ICON_SIZE = 24

const stackedButtonStyle = controlButtonStyle({
  size: BUTTON_SIZE,
  iconSize: ICON_SIZE,
  iconColor: "var(--d-icon-color-status-neutral)",
})

export function StackedLayout({
  isPlaying,
  currentTime,
  duration,
  showSkipButtons,
  togglePlayPause,
  handleSkipBack,
  handleSkipForward,
  handleProgressInputChange,
  handleProgressKeyDown,
}: PlayerRenderProps) {
  return (
    <div css={styles.wrapper}>
      <div css={styles.scrubberRow}>
        <time css={styles.time} dateTime={formatDatetimeDuration(currentTime)}>
          {currentTime ? formatDuration(currentTime) : "0:00"}
        </time>
        <Scrubber
          currentTime={currentTime}
          duration={duration}
          onChange={handleProgressInputChange}
          onKeyDown={handleProgressKeyDown}
        />
        <time css={styles.time} dateTime={formatDatetimeDuration(duration)}>
          {formatDuration(duration)}
        </time>
      </div>
      <div css={styles.controlsRow}>
        {showSkipButtons && (
          <ControlButton
            icon="skipBack"
            label="Skip back 15 seconds"
            onClick={handleSkipBack}
            buttonStyle={stackedButtonStyle}
          />
        )}
        <ControlButton
          icon={isPlaying ? "pause" : "play"}
          label={isPlaying ? "Pause" : "Play"}
          onClick={togglePlayPause}
          buttonStyle={stackedButtonStyle}
        />
        {showSkipButtons && (
          <ControlButton
            icon="skipForward"
            label="Skip forward 30 seconds"
            onClick={handleSkipForward}
            buttonStyle={stackedButtonStyle}
          />
        )}
      </div>
    </div>
  )
}

const styles = {
  wrapper: css`
    --scrubber-track-color: var(--d-fill-color-neutral-090);
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  scrubberRow: css`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
  `,
  controlsRow: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
  `,
  time: css`
    font-size: 14px;
    color: var(--d-text-color-secondary);
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  `,
}
